import { Component, input, model, output } from '@angular/core';

@Component({
  selector: 'app-primeng-input-number',
  templateUrl: './primeng-input-number.component.html',
  styleUrls: ['./primeng-input-number.component.scss'],
  standalone: false,
})
export class PrimengInputNumberComponent {
  value = model<number | null>(null);
  placeholder = input<string>('');
  disabled = input<boolean>(false);
  readonly = input<boolean>(false);
  min = input<number | null>(null);
  max = input<number | null>(null);
  step = input<number>(1);
  showButtons = input<boolean>(false);
  buttonLayout = input<'stacked' | 'horizontal' | 'vertical'>('stacked');
  prefix = input<string>('');
  suffix = input<string>('');
  currency = input<string>('');
  mode = input<'decimal' | 'currency'>('decimal');
  locale = input<string>('');
  minFractionDigits = input<number | null>(null);
  maxFractionDigits = input<number | null>(null);
  useGrouping = input<boolean>(true);
  styleClass = input<string>('');
  fluid = input<boolean>(false);
  id = input<string>('');
  label = input<string>('');
  showClear = input<boolean>(false);

  onInput = output<any>();
  onBlur = output<Event>();
  onFocus = output<Event>();

  handleChange(event: any) {
    this.value.set(event.value);
    this.onInput.emit(event);
  }

  handleBlur(event: Event) {
    this.onBlur.emit(event);
  }

  handleFocus(event: Event) {
    this.onFocus.emit(event);
  }
}
